module.exports = __webpack_public_path__ + "static/media/Jaworski Vance Headshot_1637703901235.01f3b102.png";